import React from "react";
import Draggable from "react-draggable";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
////// Mui
import { Dialog, DialogTitle, DialogContent, Paper } from "@mui/material";
import { Box, Grid, LinearProgress, Typography } from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";
////// Store
import { setPopupSimple } from "../../../redux/slices/popupSimpleSlice";
////// Controls & Components
import ButtonAction from "../Buttons/ButtonAction";

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-popupsimple-title" cancel={'[class*="popupsimple-cancel"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const PopupSimple = ({ title, children }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const mdMediaDown = useMediaQuery(theme.breakpoints.down("md"));
  const { loadingStatus } = useSelector((state) => state.loadingStatusSlice);
  const { popupSimple } = useSelector((state) => state.popupSimpleSlice);

  function handleEscClose() {
    dispatch(setPopupSimple(false));
  }

  return (
    <React.Fragment>
      <Dialog
        open={popupSimple}
        maxWidth="lg"
        sx={{
          "& .MuiDialog-container": {
            justifyContent: "flex-center",
            alignItems: "flex-start",
          },
        }}
        PaperProps={{
          sx: {
            mt: 2,
            m: mdMediaDown ? 0.75 : undefined,
          },
        }}
        onClose={handleEscClose}
        PaperComponent={PaperComponent}
        BackdropProps={{ style: { backgroundColor: "rgba(0,0,0,0.1)" } }}
      >
        <DialogTitle sx={{ bgcolor: "#f5f5f5" }}>
          <Grid container item>
            <Grid item xs={9} id="draggable-popupsimple-title">
              <Typography variant="h6">{title}</Typography>
            </Grid>

            <Grid container item xs={3} justifyContent={"flex-end"} id="popupsimple-cancel">
              <ButtonAction color="secondary" onClick={() => handleEscClose()}>
                {t("button.esc")}
              </ButtonAction>
            </Grid>
          </Grid>
        </DialogTitle>

        <Box sx={{ width: "100%" }}>
          {loadingStatus === true ? <LinearProgress /> : <LinearProgress variant="determinate" value={100} />}
        </Box>

        <DialogContent sx={{ p: 1.5 }} dividers>
          {children}
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default PopupSimple;
